import { isEmpty, map } from "lodash";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components";
import { type DailyReport, paymentAmountCents } from "@/helpers/daily-report";
import { documentNumber } from "@/helpers/document-number";
import { euros, Section, tableClassName } from "./layout";

const Sales = ({ report }: { report: DailyReport }) => {
	const { t } = useTranslation();

	return (
		<Section title={t("dailyReport.sales")}>
			{isEmpty(report.sales) ? (
				<p className="text-center text-sm">{t("dailyReport.emptySales")}</p>
			) : (
				<table className={tableClassName}>
					<thead>
						<tr>
							<th>{t("dailyReport.receipt")}</th>
							<th className="text-right!">{t("dailyReport.items")}</th>
							<th className="text-right!">{t("dailyReport.totalAmount")}</th>
							<th className="pl-4">{t("dailyReport.payments")}</th>
						</tr>
					</thead>
					<tbody className="tabular-nums">
						{map(
							report.sales,
							({ sale, isRefund, itemsCount, totalAmountCents }) => (
								<tr key={sale.id}>
									<td>
										<div className="flex items-center gap-2">
											{documentNumber(sale.number)}
											{isRefund && (
												<Badge variant="warning">
													{t("dailyReport.refund")}
												</Badge>
											)}
										</div>
									</td>
									<td className="text-right">{itemsCount}</td>
									<td className="text-right">{euros(totalAmountCents)}</td>
									<td className="pl-4">
										{map(sale.salePayments, (payment) => (
											<div
												className="flex justify-between gap-2"
												key={payment.id}
											>
												<span>
													{payment.paymentType?.name ??
														t("dailyReport.unknownPaymentType")}
												</span>
												<span>{euros(paymentAmountCents(payment))}</span>
											</div>
										))}
									</td>
								</tr>
							),
						)}
					</tbody>
				</table>
			)}
		</Section>
	);
};

export default Sales;
